// Used in assign-cart-content-builder.component.html

// Angular
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import {
    MatTab,
    MatTabGroup,
    MatTabHeader,
} from "@angular/material/tabs";

// RXJS/Store
import { Observable, Subject } from "rxjs";

// Services/Types/Helpers
import { LanguageHelper } from "#helpers/language.helper";
import { EditionId, SubjectId } from "@carnegie-learning/common-types";
import { AssetAssociation, CustomActivity, Edition, Perform } from "@carnegie-learning/cure-types";

@Component({
    selector: "activity-builder",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./activity-builder.component.html",
    styleUrls: ["./activity-builder.component.scss"],
    standalone: false
})
export class ActivityBuilderComponent implements OnInit, OnDestroy, OnChanges {
    isTeacher = false;
    public isMath = false;
    private ngUnsubscribe = new Subject();

    @Input() isDistributor = false;
    @Input() subjectId: SubjectId = "";
    @Input() editionId: EditionId = "";
    @Input() userGUID?: string;
    @Input() stimulusTask$?: Observable<CustomActivity>;
    @Input() activePrograms?: AssetAssociation[];
    @Input() activeEditions!: Edition[];
    @Input() activityFormValidity = false;
    @Input() editingActivity = false;
    @Input() customActivity?: CustomActivity;
    @Input() currentCustomActivityFormData?: CustomActivity;
    @Input() currentPerformActivityFormData?: Perform;

    @Output() setActivityFormValidity = new EventEmitter<boolean>();
    @Output() setCustomActivityFormData = new EventEmitter<CustomActivity>();
    @Output() setPerformActivityFormData = new EventEmitter<Perform>();
    @Output() clearActivityForm = new EventEmitter<void>();

    @ViewChild("tabs", { static: true }) tabs?: MatTabGroup;

    constructor(private languageHelper: LanguageHelper) {}

    ngOnInit() {}

    ngOnChanges() {
        if (this.tabs) {
            this.tabs._handleClick = this.interceptTabChange.bind(this);
            if (this.currentPerformActivityFormData) {
                this.tabs.selectedIndex = 2;
            }
        }
        if (!this.subjectId && this.editionId) {
            const edition = this.activeEditions.find(
                (e) => e.editionId === this.editionId
            );
            if (edition) {
                this.subjectId = edition.subjectId;
            }
        }
    }

    interceptTabChange(tab: MatTab, tabHeader: MatTabHeader, idx: number) {
        if (
            this.currentCustomActivityFormData ||
            this.currentPerformActivityFormData
        ) {
            let result = false;
            if (!this.editingActivity) {
                result = confirm(
                    `You have started to create this activity. Leaving this tab will clear any unsaved work.`
                );
            }
            return (
                result &&
                MatTabGroup.prototype._handleClick.call(
                    this.tabs,
                    tab,
                    tabHeader,
                    idx
                )
            );
        } else {
            return MatTabGroup.prototype._handleClick.call(
                this.tabs,
                tab,
                tabHeader,
                idx
            );
        }
    }

    setCustomActivityFormDataFn(event: CustomActivity) {
        this.setCustomActivityFormData.emit(event);
    }
    setPerformActivityFormDataFn(event: Perform) {
        this.setPerformActivityFormData.emit(event);
    }

    setActivityFormValidityFn(event: boolean) {
        this.setActivityFormValidity.emit(event);
    }

    isMathClass() {
        if (this.languageHelper.ifMathLanguage(this.subjectId)) {
            return true;
        }
    }

    checkIfFormActive() {
        this.clearActivityForm.emit();
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }
}
